import { useState, type FormEvent } from "react";

const steps = [
  { icon: "ri-edit-box-line", title: "撰写爆料", desc: "说明事件时间、地点与经过，尽量客观详实，记得对个人信息做脱敏。" },
  { icon: "ri-tools-fill", title: "平台审核", desc: "内容进入人工审核流程，通常在 24 小时内完成，不实与侵权内容会被退回。" },
  { icon: "ri-global-fill", title: "专区上墙", desc: "审核通过后按分类进入对应专区，进入最新爆料流，与千万网友见面。" },
  { icon: "ri-chat-smile-3-fill", title: "互动发酵", desc: "网友评论留言、点赞转发实时展开，你的线索随时可能成为下一个大瓜。" },
];

const categories = ["娱乐八卦", "消费维权", "职场见闻", "科技数码", "生活趣事", "社会热点"];

export default function SubmitZone() {
  const [category, setCategory] = useState(categories[0]);
  const [msgLen, setMsgLen] = useState(0);
  const [status, setStatus] = useState<"idle" | "ok" | "err">("idle");
  const [formError, setFormError] = useState("");
  const [okMsg, setOkMsg] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = String(data.get("website_alt") || "").trim();

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key !== "website_alt" && String(value).trim() !== "") payload.append(key, String(value));
    });

    if (honeypot !== "") {
      setStatus("ok");
      setOkMsg("投稿已提交，我们会在审核后与您联系。感谢您的支持！");
      form.reset();
      setMsgLen(0);
      return;
    }

    try {
      const res = await fetch("https://readdy.ai/api/form/dae0gcbep053ijub16gg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || responseText || "";
      if (res.ok && parsed?.code === "OK") {
        setStatus("ok");
        setOkMsg("投稿成功！您的爆料已进入审核流程，感谢分享这条线索。");
        form.reset();
        setMsgLen(0);
        setCategory(categories[0]);
      } else {
        setStatus("err");
        setFormError(serverMsg.includes("spam") ? "提交内容被判定为疑似垃圾信息，请调整后重试。" : serverMsg || "投稿提交失败，请稍后重试。");
      }
    } catch {
      setStatus("err");
      setFormError("网络异常，投稿暂未成功，请检查网络后重试。");
    }
  }

  return (
    <section id="submit" className="relative mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
      <div className="grid gap-10 lg:grid-cols-[1fr_1.15fr] items-start">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-[#ff4d3d]/10 text-[#ff4d3d] text-sm font-medium px-4 py-1.5">
            <i className="ri-upload-cloud-2-line w-4 h-4 flex items-center justify-center"></i> 投稿通道
          </span>
          <h2 className="mt-5 font-serif-cn text-2xl md:text-4xl font-black text-[#201d1a] leading-snug">
            手上有料？<br className="hidden sm:block" />
            赶紧来<b className="text-emerald-600">爆瓜</b>吧
          </h2>
          <p className="mt-4 text-[#201d1a]/65 leading-relaxed">
            无论是独家见闻、消费踩坑还是身边趣事，只要真实有料，都可以投给我们。一次投稿，直达专区，让千万吃瓜群众一起参与讨论。
          </p>

          <ol className="mt-8 space-y-4">
            {steps.map((s, i) => (
              <li key={s.title} className="flex gap-4">
                <div className="flex flex-col items-center">
                  <span className="grid w-10 h-10 rounded-full bg-emerald-600 text-white place-items-center shrink-0">
                    <i className={`${s.icon} w-5 h-5 flex items-center justify-center`}></i>
                  </span>
                  {i < steps.length - 1 && <span className="w-px flex-1 bg-amber-900/10 my-1"></span>}
                </div>
                <div className="pb-1">
                  <h3 className="font-bold text-[#201d1a] flex items-center gap-2">
                    <span className="font-serif-cn text-[#ff4d3d]">{i + 1}</span>
                    {s.title}
                  </h3>
                  <p className="mt-1 text-sm text-[#201d1a]/60 leading-relaxed">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className="mt-6 flex items-start gap-2 rounded-xl bg-amber-100/70 p-4 text-sm text-[#201d1a]/70">
            <i className="ri-shield-check-line w-5 h-5 flex items-center justify-center text-emerald-600 shrink-0"></i>
            <p>我们倡导真实、理性、客观的讨论。严禁捏造事实、传播不实信息或进行人身攻击，违规内容将被下架处理。</p>
          </div>
        </div>

        <form
          data-readdy-form
          onSubmit={handleSubmit}
          className="rounded-3xl bg-white border border-amber-900/10 p-6 md:p-8"
        >
          <div className="grid gap-5 sm:grid-cols-2">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-[#201d1a] mb-2">
                你的昵称 <span className="text-[#ff4d3d]">*</span>
              </label>
              <input
                id="name"
                name="name"
                required
                placeholder="怎么称呼你"
                className="w-full rounded-lg border border-amber-900/15 bg-[#fbf7ef] px-4 py-3 text-[15px] text-[#201d1a] outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 transition"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-[#201d1a] mb-2">
                联系方式邮箱
              </label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="选填，用于审核沟通"
                className="w-full rounded-lg border border-amber-900/15 bg-[#fbf7ef] px-4 py-3 text-[15px] text-[#201d1a] outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 transition"
              />
            </div>
          </div>

          <div className="mt-5">
            <label htmlFor="title" className="block text-sm font-medium text-[#201d1a] mb-2">
              爆料标题 <span className="text-[#ff4d3d]">*</span>
            </label>
            <input
              id="title"
              name="title"
              required
              maxLength={60}
              placeholder="一句话概括你要爆的瓜"
              className="w-full rounded-lg border border-amber-900/15 bg-[#fbf7ef] px-4 py-3 text-[15px] text-[#201d1a] outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 transition"
            />
          </div>

          <div className="mt-5">
            <span className="block text-sm font-medium text-[#201d1a] mb-2">
              归属分类 <span className="text-[#ff4d3d]">*</span>
            </span>
            <div className="flex flex-wrap gap-2">
              {categories.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setCategory(c)}
                  className={`px-4 py-2 rounded-full text-sm transition-colors whitespace-nowrap ${
                    category === c
                      ? "bg-emerald-600 text-white font-medium"
                      : "bg-[#fbf7ef] border border-amber-900/15 text-[#201d1a]/70 hover:border-emerald-600/40"
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
            <input type="hidden" name="category" value={category} />
          </div>

          <div className="mt-5">
            <label htmlFor="message" className="flex items-center justify-between text-sm font-medium text-[#201d1a] mb-2">
              <span>事件描述 <span className="text-[#ff4d3d]">*</span></span>
              <span className={`text-xs ${msgLen >= 500 ? "text-[#ff4d3d]" : "text-[#201d1a]/40"}`}>{msgLen}/500</span>
            </label>
            <textarea
              id="message"
              name="message"
              required
              rows={5}
              maxLength={500}
              onChange={(e) => setMsgLen(e.target.value.length)}
              placeholder="请描述事件的经过、时间、地点与关键细节，帮助更多网友快速理解。"
              className="w-full rounded-lg border border-amber-900/15 bg-[#fbf7ef] px-4 py-3 text-[15px] text-[#201d1a] outline-none focus:border-emerald-600 focus:ring-2 focus:ring-emerald-600/20 transition resize-none"
            ></textarea>
          </div>

          <input type="text" name="website_alt" autoComplete="off" aria-hidden="true" readOnly tabIndex={-1} className="submit-honey" />

          <button
            type="submit"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-lg bg-[#ff4d3d] px-7 py-3.5 font-semibold text-white hover:bg-[#e63e30] transition-colors whitespace-nowrap"
          >
            <i className="ri-send-plane-fill w-5 h-5 flex items-center justify-center"></i>
            提交爆料
          </button>

          {status === "ok" && (
            <p className="mt-4 flex items-center gap-2 rounded-lg bg-emerald-600/10 text-emerald-700 px-4 py-3 text-sm">
              <i className="ri-checkbox-circle-fill w-5 h-5 flex items-center justify-center"></i>
              {okMsg}
            </p>
          )}
          {status === "err" && (
            <p className="mt-4 flex items-center gap-2 rounded-lg bg-[#ff4d3d]/10 text-[#ff4d3d] px-4 py-3 text-sm">
              <i className="ri-error-warning-fill w-5 h-5 flex items-center justify-center"></i>
              {formError}
            </p>
          )}
          <p className="mt-4 text-xs text-[#201d1a]/45 leading-relaxed">
            提交即表示你同意内容真实可靠，并授权平台在遵守社区规则的前提下进行展示与互动。我们重视你的隐私，所留信息仅用于审核沟通。
          </p>
        </form>
      </div>
    </section>
  );
}